/* =========================================================
   CAPABILITIES
========================================================= */
import React from "react";
import SectionHeader from "./SectionHeader";

const CapabilitiesSection = ({ data }) => (
    <section id="students">

        <div className="container">

            <SectionHeader
                title={data.title}
                description={data.description}
            />

            <div className="capabilities">

                {(data.items || []).map((item, i) => (
                    <div className="capability" key={i}>

                        <div className="capability-number">
                            {String(i + 1).padStart(2, "0")}
                        </div>

                        <h3>{item.title}</h3>

                        <p>{item.description}</p>

                    </div>
                ))}

            </div>

        </div>

    </section>
);

export default CapabilitiesSection;